//copied from v1
import React, { useState, useEffect } from "react";
import copy from "copy-to-clipboard";
import { Box, Text, Button } from "@indeed/ifl-components";
import Link from "@indeed/ifl-icons/Link";
import { Popover } from "react-tiny-popover";

const CopyButton = ({ label = "Copy", text, options = {}, onCopy, sx }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 1000);
    }
  }, [isCopied]);

  const handleClick = () => {
    const result = copy(text, options);
    if (onCopy) {
      onCopy(text, result);
    }
    setIsCopied(true);
  };

  return (
    <Popover
      isOpen={isOpen}
      content={
        <Box>
          <Text sx={{ py: 3 }}>{isCopied ? "Copied!" : label}</Text>
        </Box>
      }
      positions={["bottom", "top", "left", "right"]}
    >
      <Button
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        variant="tertiary"
        size="sm"
        aria-label="copy button"
        title="copy button"
        iconOnly
        sx={{
          borderRadius: "100%",
          height: "34px",
          "&:hover": {
            color: "neutral.1000",
          },
          ...sx,
        }}
        onClick={handleClick}
      >
        <Link title="" />
      </Button>
    </Popover>
  );
};

export default CopyButton;
